var map = {
	"./appAsset-flag--BR.svg": "4e50",
	"./appAsset-flag--CL.svg": "196a",
	"./appAsset-flag--CO.svg": "5956",
	"./appAsset-flag--ES.svg": "f494",
	"./appAsset-flag--MX.svg": "5633",
	"./appAsset-flag--PE.svg": "b165",
	"./appAsset-flag--US.svg": "54896"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b22";